<template>
    <MainContentSearchable id="bases" v-model="filters" :meta="loading ? {} : bases.meta" @updated="debouncedGetBases">
        <template v-slot:header>
            <h3>Listado de deportistas</h3>
        </template>
        <template v-slot:content>
            <div v-if="!loading">
                <ListadoDeportistas :bases="bases"/>
            </div>
            <LoaderComponent v-else/>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import ListadoDeportistas from "../components/ListadoDeportistas"

    export default {
        data() {
            return {
                bases: { data: [], meta: { current_page: 1 } },
                categoria_id: this.$route.params.categoria_id,
                loading: false,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: '',
                },
            }
        },
        created() {
            this.getBases();
            this.debouncedGetBases = _.debounce(this.getBases, 500)
        },
        methods: {
            getBases() {
                this.loading = true;

                let params = {
                    lista_id: this.lista_id,
                    categoria_id: this.categoria_id,
                    filters: this.filters
                };
                this.$store.dispatch(this.config.getVuexAlias('back.bases.categorias.resumen.bases'), params).then(res => {
                    this.bases = res.data;
                }).finally(() => this.loading = false);
            }
        },
        computed: {
            lista_id() {
                return this.$route.params.lista_id;
            }
        },
        components: {
            MainContentSearchable, ListadoDeportistas
        }
    }
</script>
